import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Socials from './components/Socials';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProjectsPage from './pages/ProjectsPage';
import OngoingPage from './pages/OngoingPage';
import VisionPage from './pages/VisionPage';
import TeamPage from './pages/TeamPage';
import ContactPage from './pages/ContactPage';
import './styles/variables.css';
import './styles/animations.css';
import './styles/responsive.css';
import './App.css';

function App() {
  // Removed expensive parallax effect for better performance
  
  return (
    <Router>
      <Navigation />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/ongoing" element={<OngoingPage />} />
        <Route path="/vision" element={<VisionPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
      <Socials />
      <Footer />
    </Router>
  );
}

export default App;
